import ParameterErrors from '../errors/ParameterErrors';
import enableBindingToOthers from '../mvvm/enableBindingToOthers';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import WhenFinishedModifying from '../core/WhenFinishedModifying';
import Timer from '../core/Timer';
import BrochureProgressStatus from '../enums/BrochureProgressStatus';
import BrochureType from '../enums/BrochureType';
import Tooltip from '../components/Tooltip';
const {throwNotProvided}=ParameterErrors;
export default class BrochuresMenuEntry{	
	constructor(params){
		const { brochureBeingGenerated }=params;
		enableBindingToOthers(this);
		if(!brochureBeingGenerated)throwNotProvided('brochureBeingGenerated');
		this._brochureBeingGenerated = brochureBeingGenerated;
		this.dispose = this.dispose.bind(this);
		this._update = this._update.bind(this);
		this._whenFinishedModifying = new WhenFinishedModifying({delay:100, callback:this._update});
		this._brochureProgressStatusChanged = this._brochureProgressStatusChanged.bind(this);
		this._brochureUrlChanged = this._brochureUrlChanged.bind(this);
		this._proportionProgressChanged = this._proportionProgressChanged.bind(this);
		this._updateProgressBarProportion = this._updateProgressBarProportion.bind(this);
		this._currentBrochureProgressStatusClass = null;
		this._element = document.createElement('div');
		this._element.classList.add('brochures-menu-entry');
		this._progressElement = document.createElement('div');
		this._progressElement.classList.add('progress');
		this._element.appendChild(this._progressElement);
		this._innerElement = document.createElement('div');
		this._innerElement.classList.add('inner');
		this._element.appendChild(this._innerElement);
		this._textElement = document.createElement('div');
		this._textElement.classList.add('text');
		this._innerElement.appendChild(this._textElement);
		this._handleClick= this._handleClick.bind(this);
		this._element.addEventListener('click', this._handleClick);
		this._timerUpdateProgressProportion = new Timer({callback:this._updateProgressBarProportion, delay:500, nTicks:-1});
		this._timerUpdateProgressProportion.start();
		this._propertyBindingBrochureProgressStatus = PropertyBindingFactory.standard(
			this, brochureBeingGenerated, 'brochureProgressStatus', this._brochureProgressStatusChanged);
			
		this._propertyBindingBrochureUrl= PropertyBindingFactory.standard(
			this, brochureBeingGenerated, 'brochureUrl', this._brochureUrlChanged);
			
		this._propertyBindingProportionProgress = PropertyBindingFactory.standard(
			this, brochureBeingGenerated, 'proportionProgress', this._proportionProgressChanged);
	}
	get brochureGenerationIdentifier(){
		return this._brochureBeingGenerated.brochureGenerationIdentifier;
	}
	get element(){
		return this._element;
	}
	_brochureProgressStatusChanged(){
		this._changedStatusAtMilliseconds =new Date().getTime();
		this._whenFinishedModifying.trigger();
		if(this._brochureBeingGenerated.brochureProgressStatus===BrochureProgressStatus.Generated)
			this._timerUpdateProgressProportion.stop();
	}
	_brochureUrlChanged(){
		this._whenFinishedModifying.trigger();
	}
	_proportionProgressChanged(){
		this._whenFinishedModifying.trigger();
	}
	_update(){
		this._updateBrochureProgressStatusClassOnElement();
		this._updateProgressBarProportion();
		const text = this._getText();
		this._textElement.innerHTML = text;
	}
	_updateBrochureProgressStatusClassOnElement(){
		if(this._currentBrochureProgressStatusClass)
			this._element.classList.remove(this._currentBrochureProgressStatusClass);
		const className = BrochureProgressStatus.getClassName(this._brochureBeingGenerated.brochureProgressStatus);
		this._currentBrochureProgressStatusClass = className;
		this._element.classList.add(className);
	}
	_updateProgressBarProportion(){
		let progressPercent=0;
		const millisecondsSinceChangedStatus = new Date().getTime() - this._changedStatusAtMilliseconds ;
		const neverGetThereProportion = 1-Math.pow(2, -millisecondsSinceChangedStatus/3000);
		switch(this._brochureBeingGenerated.brochureProgressStatus){
			case BrochureProgressStatus.Queued:
				progressPercent=15+(35*neverGetThereProportion);
				break;
			case BrochureProgressStatus.Generating:
			const proportionProgress = this._brochureBeingGenerated.proportionProgress;
				progressPercent=50+(50*neverGetThereProportion);
				break;
			case BrochureProgressStatus.Generated:
				progressPercent=100;
				break;
			default:
				throw new Error('Not implemented');
		}
		this._progressElement.style.width=String(progressPercent)+'%';
	}
	_getText(){
		
		const brochureType = this._brochureBeingGenerated.brochureType;
		let text='';
		switch(this._brochureBeingGenerated.brochureProgressStatus){
			case BrochureProgressStatus.Queued:
				text+='Queued: ';
				break;
			case BrochureProgressStatus.Generating:
				text+='Generating: ';
				break;
			case BrochureProgressStatus.Generated:
				text+='Download ';
				break;
			default:
				throw new Error('Not implemented');
		}
		text+=BrochureType.getString(brochureType);
		text+=' Brochure';
		const plotNumbers = this._brochureBeingGenerated.plotNumbers;
		if(plotNumbers
			&&(plotNumbers.length>0)
			&&(brochureType!==BrochureType.FavouritesAllPlots)
			&&(brochureType!==BrochureType.FavouritesAllHouseTypes)
			)
			text+=' <div class="plot-numbers">(Plots '+plotNumbers.join(',')+')</div>';
		return text;
	}
	_handleClick(){
		if(this._brochureBeingGenerated.brochureProgressStatus!==BrochureProgressStatus.Generated){
			this._showDownloadedBrochuresWillAppearHere();
			return;
		}
		window.open(this._brochureBeingGenerated.brochureUrl, '_blank').focus();
	}
	dispose(){
		this.bindingsHandler.dispose();
	}
}